import { EMPTY_FUNCTION } from '../../../constants/common'
import { ListItemContent } from '../../ListItem'
import { Radio, RADIO_SIZE } from '../../Radio'

import * as styles from './UserMenuThemeModeOption.module.css'

// The row's click selects the option, so the radio only mirrors the mode
function UserMenuThemeModeOption({
  Preview,
  isChecked,
  value,
  ...contentProps
}) {
  return (
    <>
      <Radio
        checked={isChecked}
        containerProps={{ className: styles.radioContainer }}
        labelProps={{ className: styles.radioLabel }}
        size={RADIO_SIZE.xSmall}
        value={value}
        onChange={EMPTY_FUNCTION}
      />
      <Preview className={styles.preview} />
      <ListItemContent {...contentProps} value={value} />
    </>
  )
}

export default UserMenuThemeModeOption
